import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        const brandFieldId = this.data.get("brandField");
        if (!brandFieldId)
            return;
        const brandField = document.getElementById(brandFieldId);
        if (!brandField)
            return;
        // Listen for changes on the brand field
        brandField.addEventListener("input", () => this.updateOptions(brandField.value));
    }
    async updateOptions(brandName) {
        if (!brandName) {
            this.clearOptions();
            return;
        }
        try {
            const response = await fetch(`/brand_models?brand_name=${encodeURIComponent(brandName)}&machine_type=tractor`);
            const models = await response.json();
            this.clearOptions();
            const datalist = this.element.querySelector("datalist");
            if (!datalist)
                return;
            models.forEach((model) => {
                const option = document.createElement("option");
                option.value = model.name;
                option.dataset.id = String(model.id);
                option.dataset.autocompleteTarget = "option";
                datalist.appendChild(option);
            });
            this.optionTargets = Array.from(this.element.querySelectorAll("[data-autocomplete-target='option']"));
        }
        catch (error) {
            console.error("Failed to load brand models:", error);
        }
    }
    clearOptions() {
        const datalist = this.element.querySelector("datalist");
        if (!datalist)
            return;
        datalist.innerHTML = "";
    }
    syncAutocompleteId(_) {
        const value = this.inputTarget.value;
        const match = this.optionTargets.find((option) => option.value === value);
        if (this.hiddenTarget) {
            this.hiddenTarget.value = match?.dataset.id || "";
        }
        if (match) {
            this.lockInput();
        }
    }
    lockInput() {
        this.inputTarget.readOnly = true;
        this.inputTarget.disabled = true;
        this.editButtonTarget.classList.remove("d-none");
    }
    unlockInput() {
        this.inputTarget.readOnly = false;
        this.inputTarget.disabled = false;
        this.inputTarget.focus();
        this.editButtonTarget.classList.add("d-none");
    }
}
default_1.targets = ["input", "hidden", "option", "editButton"];
export default default_1;
